webpackJsonp([125],{

/***/ "BjDr":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/company_c450981907dc70f2db6d5e828864bd87.html";

/***/ }),

/***/ "Ypo8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SmoothScroll_1 = __webpack_require__("OSKg");
var Company = (function () {
    Company.$inject = ["$stateParams", "$rootScope", "$state"];
    function Company($stateParams, $rootScope, $state) {
        var _this = this;
        this.$stateParams = $stateParams;
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.onScreen = '50';
        this.tabs = [
            {
                name: 'about',
                scrollTo: '.about-section',
                offset: 100
            },
            {
                name: 'studio',
                scrollTo: '.press-product-section.studio',
                offset: 60
            },
            {
                name: 'press',
                scrollTo: '.press-section',
                offset: 60
            }
        ];
        this.onScreenObservers = [];
        if (this.$stateParams.tab) {
            setTimeout(function () {
                _this.changeTab(_this.$stateParams.tab);
                _this.observeOnScreen();
            }, 500);
        }
        else {
            this.observeOnScreen();
        }
    }
    Company.prototype.$onDestroy = function () {
        this.onScreenObservers.forEach(function (f) { return f(); });
    };
    Company.prototype.changeTab = function (nextTabName) {
        var nextTab = this.tabs.filter(function (tab) { return tab.name === nextTabName; })[0];
        this.activeTab = nextTab.name;
        this.scroll(nextTab);
        this.stateGo(nextTab.name);
    };
    Company.prototype.stateGo = function (nextTabName) {
        var params = {
            tab: nextTabName
        };
        var options = {
            notify: false,
            location: 'replace'
        };
        this.$state.go(this.$state.current, params, options);
    };
    Company.prototype.scroll = function (tab) {
        var scrollElement = document.querySelector(tab.scrollTo);
        var offset = tab.offset || 0;
        var scrollSvc = new SmoothScroll_1.SmoothScroll(scrollElement, offset);
        scrollSvc.scroll();
    };
    Company.prototype.observeOnScreen = function () {
        var _this = this;
        var cb = _.debounce(function (tab) {
            _this.activeTab = tab.name;
            _this.stateGo(tab.name);
        }, 300);
        this.tabs.forEach(function (tab) {
            var observer = _this.$rootScope.$on("onScreen:" + tab.name, function () { return cb(tab); });
            _this.onScreenObservers.push(observer);
        });
    };
    return Company;
}());
angular.module('animatronApp.company', []).component('company', {
    controller: Company,
    templateUrl: __webpack_require__("BjDr")
});


/***/ })

});


// WEBPACK FOOTER //
// javascripts/125-0e7693f8a3788edda5d0.min.js